var _Object$setPrototypeOf = require("core-js-pure/features/object/set-prototype-of.js");
var _bindInstanceProperty = require("core-js-pure/features/instance/bind.js");
var _Object$getPrototypeOf = require("core-js-pure/features/object/get-prototype-of.js");
function _getPrototypeOf(o) {
  var _context;
  module.exports = _getPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
    return o.__proto__ || _Object$getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;